/** Address a person pastes when adding JuDI in Grok, Claude, ChatGPT, or Codex. */
export function hostedMcpUrl(origin = window.location.origin): string {
  return `${origin.replace(/\/$/, "")}/mcp`;
}

async function hostedFetch(
  path: string,
  init: RequestInit = {},
): Promise<{
  ok: boolean;
  status: number;
  payload: Record<string, unknown>;
}> {
  // Loaded here, not at import, so hostedMcpUrl can be tested without
  // the server keys the rest of this file needs.
  const { SUPABASE_ANON_KEY, SUPABASE_URL, supabase } = await import("./supabase");
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  const origin = window.location.origin;
  let response: Response;
  try {
    response = await fetch(`${SUPABASE_URL}/functions/v1/judi-mcp${path}`, {
      ...init,
      headers: {
        "Content-Type": "application/json",
        apikey: SUPABASE_ANON_KEY,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        "x-judi-public-url": `${origin}${path}`,
        ...(init.headers ?? {}),
      },
    });
  } catch {
    // No answer at all: offline, or an error the browser hid. Say so, so the
    // page does not wait on "Connecting…" forever.
    return {
      ok: false,
      status: 0,
      payload: {
        error: "Could not reach JuDI. Check your connection and try again.",
      },
    };
  }
  let payload: Record<string, unknown> = {};
  try {
    payload = (await response.json()) as Record<string, unknown>;
  } catch {
    payload = { error: "JuDI did not answer." };
  }
  return { ok: response.ok, status: response.status, payload };
}

export async function readHostedConnectRequest(rid: string) {
  return hostedFetch(`/oauth/request?rid=${encodeURIComponent(rid)}`, {
    method: "GET",
  });
}

export async function finishHostedConnect(
  rid: string,
  choice: { scope: "read" | "read_write" | "read_write_delete" } | { deny: true },
) {
  return hostedFetch("/oauth/consent", {
    method: "POST",
    body: JSON.stringify({ rid, ...choice }),
  });
}
